import { createFeatureSelector, createSelector } from '@ngrx/store';

export const selectAdmin = createFeatureSelector('admin');

export const selectAdminAlert = createSelector(selectAdmin, (state: any) => state.alert);
